import React, { useState, useEffect, useCallback } from "react";
import "./organization-access-list-delete.scss";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMatch } from "react-router-dom";
import {
  clearNotifications,
  selectAccessListNotifications,
  getOrganizationAccessList,
  selectCurrentList,
  setSelectedList,
  deleteOrganizationAccessList,
} from "../../reducers/accessSlice";

import { setNotifications } from "../../reducers/appSlice";
import { getRemoveTitle, removeItemForm } from "../../forms/DeleteForm";
import OrganizationAccessListItem from "./organization-access-list-item";

const OrganizationAccessListDelete = () => {
  const [isValid, setIsValid] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matchEdit = useMatch("/:id/access/:accessListID/*");

  const accessNotifications = useSelector(selectAccessListNotifications);
  const currentList = useSelector(selectCurrentList);

  const backToList = () => {
    navigate(`/${matchEdit.params.id}/access/${matchEdit.params.accessListID}`);
  };

  const loadMember = useCallback(() => {
    dispatch(getOrganizationAccessList(matchEdit?.params?.accessListID));
  }, [dispatch, matchEdit?.params]);

  useEffect(() => {
    loadMember();
    return () => {
      dispatch(setSelectedList({}));
    };
  }, [loadMember, dispatch]);

  useEffect(() => {
    if (
      accessNotifications.length > 0 &&
      accessNotifications[0].state === "success"
    ) {
      dispatch(setNotifications(accessNotifications));
      dispatch(clearNotifications());
      navigate(`/${matchEdit.params.id}/access`);
    }
  }, [accessNotifications, dispatch, navigate, matchEdit.params.id]);

  const deleteList = () => {
    setIsValid(false);
    if (matchEdit.params.id) {
      dispatch(deleteOrganizationAccessList(currentList));
    }
  };

  const leftNavigation = () => {
    backToList();
  };

  const getActions = () => {
    let actions = [
      {
        name: "Delete",
        action: deleteList,
        isDisabled: !isValid,
        type: "red",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Delete Access List",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    const slideOutNotifications = accessNotifications;
    if (hasNotifications(slideOutNotifications)) {
      return {
        notifications: slideOutNotifications.map((n) => ({
          ...n,
          pageActions: getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "Back to Access List",
        size: "secondary",
        actionClick: backToList,
      },
    ];
  };
  const getContent = () => {
    return (
      <GSForm
        formTitle={getRemoveTitle("Delete Access List")}
        formSections={removeItemForm(
          currentList?.name,
          <OrganizationAccessListItem {...currentList} />,
          "delete"
        )}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };
  return (
    <organization-access-list-delete>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </organization-access-list-delete>
  );
};

export default OrganizationAccessListDelete;
